'use client'
import {
  __spreadValues
} from "./chunk-UYSR6ZT4.mjs";

// src/utils/utm.ts
import { getItem, readCookie, safeParseJson } from "@wbk/utils";
var EXCLUDED_URL_PARAMS = ["redirect", "redirect_failed"];
var parseGaSessionId = (value) => {
  var _a;
  if (!/^GS\d+\.\d+\./.test(value)) return;
  const gs2 = (_a = value.match(/(?:\$|\.)s(\d+)/)) == null ? void 0 : _a[1];
  if (gs2) return gs2;
  const gs1 = value.split(".")[2];
  return /^\d+$/.test(gs1 || "") ? gs1 : void 0;
};
var getGaIdentity = () => {
  var _a, _b;
  if (typeof document === "undefined") return {};
  const identity = {};
  const clientId = (_b = (_a = readCookie("_ga")) == null ? void 0 : _a.match(/^GA\d+\.\d+\.(\d+\.\d+)$/)) == null ? void 0 : _b[1];
  if (clientId) identity.ga_client_id = clientId;
  for (const cookie of document.cookie.split(";")) {
    const [name, ...rest] = cookie.trim().split("=");
    if (!(name == null ? void 0 : name.startsWith("_ga_"))) continue;
    const sessionId = parseGaSessionId(rest.join("="));
    if (sessionId) identity[name] = sessionId;
  }
  return identity;
};
var PIXEL_COOKIES = {
  fbp: "_fbp",
  fbc: "_fbc"
};
var getAnalyticsUtmsFromStorage = () => {
  if (typeof window !== "undefined") {
    const savedUtms = getItem("utms");
    if (!savedUtms) return null;
    const parsed = safeParseJson(savedUtms);
    return typeof parsed === "object" && parsed !== null && !Array.isArray(parsed) ? parsed : null;
  }
};
var getAnalyticsUtms = () => {
  if (typeof window === "undefined") return;
  const search = new URLSearchParams(window.location.search);
  const utm_wbk_wa_session_id = getItem("utm_wbk_wa_session_id");
  const hasUrlUtms = [...search.keys()].length > 0;
  const urlParams = __spreadValues({}, getAnalyticsUtmsFromStorage() || {});
  search.forEach((value, key) => {
    if (EXCLUDED_URL_PARAMS.includes(key)) return;
    urlParams[key] = value;
  });
  if (hasUrlUtms && utm_wbk_wa_session_id) {
    urlParams.utm_wbk_wa_session_id = utm_wbk_wa_session_id;
  }
  const campaign = hasUrlUtms ? urlParams : getAnalyticsUtmsFromStorage() || {};
  const pixelIdentity = {};
  for (const [param, cookie] of Object.entries(PIXEL_COOKIES)) {
    const value = readCookie(cookie);
    if (value) pixelIdentity[param] = value;
  }
  const allParams = __spreadValues(__spreadValues(__spreadValues({}, campaign), getGaIdentity()), pixelIdentity);
  return Object.keys(allParams).length > 0 ? allParams : void 0;
};

export {
  getGaIdentity,
  getAnalyticsUtmsFromStorage,
  getAnalyticsUtms
};
//# sourceMappingURL=chunk-T3TQF7R3.mjs.map